import { useCallback, useMemo } from "react";
import { useRemoteParticipants, useTracks } from "@livekit/components-react";
import { RoomEvent, Track } from "livekit-client";
import type { ProviderMuteAllPeersAudio } from "../types";
import { sendSignal } from "./helpers";
import { ACTION_TYPES } from "./helpers";
import { useLivekitLocalParticipant } from "./useLivekitLocalParticipant";

export const useLivekitMuteAllPeersAudio = (): ProviderMuteAllPeersAudio => {
  const localParticipant = useLivekitLocalParticipant();
  const participants = useRemoteParticipants();
  const microphoneRefs = useTracks([Track.Source.Microphone], {
    updateOnlyOn: [RoomEvent.TrackMuted, RoomEvent.TrackUnmuted],
  });

  const muteAllPeersMicrophone = useCallback(
    () =>
      participants.forEach(
        participant =>
          void sendSignal(
            ACTION_TYPES.MUTE_MICROPHONE,
            localParticipant,
            participant.identity,
          ),
      ),
    [localParticipant, participants],
  );

  const areAllPeersMuted = useMemo(
    () =>
      microphoneRefs
        .filter(ref => ref.participant.identity !== localParticipant.identity)
        .every(ref => ref.publication.isMuted),
    [microphoneRefs, localParticipant],
  );

  return {
    muteAllPeersMicrophone,
    areAllPeersMuted,
  };
};
